import classNames from 'classnames';
import FJImage from '../FJImage/FJImage';
import styles from './FJThumbnailCover.module.less';

interface FJThumbnailCoverProps {
    src: string;
    alt?: string;
    className?: string;
    loading?: 'lazy' | 'eager';
}

/**
 * 固定比例容器内展示缩略图：前景 `object-fit: contain` 居中；背面同图放大模糊铺满，用于非 16:9 等比例时的衬底。
 */
export default function FJThumbnailCover({
    src,
    alt = '',
    className,
    loading = 'lazy',
}: FJThumbnailCoverProps) {
    return (
        <div className={classNames(styles.root, className)}>
            <FJImage
                imgSrc={src}
                boxClassName={styles.bg_box}
                imgClassName={styles.bg}
                disableDefaultImgClass
                alt=''
                aria-hidden={true}
                loading={loading}
                decoding='async'
            />
            <FJImage
                imgSrc={src}
                boxClassName={styles.fg_box}
                imgClassName={styles.fg}
                disableDefaultImgClass
                alt={alt}
                loading={loading}
                decoding='async'
            />
        </div>
    );
}
